import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from "react";
import { FormGroup, Label, Input, Col, Row, Spinner } from "reactstrap";
import useDebounce from '../../hooks/useDebounce';
import { validateEmail } from "../../../../utils/formValidation";
import { IconClose } from '@sfx/icons';
import { validateEmailApi, validateGenericEmailApi, validInviteUserEmailApi } from "../../../../api";

var EmailInfo = function EmailInfo(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      checkEmailLoading = _useState2[0],
      setCheckEmailLoading = _useState2[1];

  var _useState3 = useState({
    valid: true,
    message: ""
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      emailValid = _useState4[0],
      setEmailValid = _useState4[1];

  var onInputChange = props.onInputChange,
      onEmailValidChange = props.onEmailValidChange,
      duplicateEmailCheck = props.duplicateEmailCheck,
      translate = props.translate,
      userName = props.userName,
      FirstName = props.FirstName,
      LastName = props.LastName,
      prefix = props.prefix,
      modalType = props.modalType,
      _props$isCheckInvited = props.isCheckInvitedUser,
      isCheckInvitedUser = _props$isCheckInvited === void 0 ? true : _props$isCheckInvited;

  var validateGeneric = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(email) {
      var valid, message, res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              valid = false, message = '';
              _context.prev = 1;
              _context.next = 4;
              return validateGenericEmailApi(email, {
                catchError: true
              });

            case 4:
              res = _context.sent;

              if (!res) {
                message = translate('SFxAccountSettingsUserEmailRulesTip');
              } else {
                valid = true;
                message = '';
              }

              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              valid = true;
              message = '';

            case 12:
              setEmailValid({
                valid: valid,
                message: message
              });
              return _context.abrupt("return", valid);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function validateGeneric(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var validateEmailExist = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(email) {
      var valid, message, res, _error$response, status;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              valid = false, message = '';
              _context2.prev = 1;
              _context2.next = 4;
              return validateEmailApi(email, {
                catchError: true
              });

            case 4:
              res = _context2.sent;

              if (res && res.status === 204) {
                valid = false;
                message = translate('SFxAccountSettingsUserEmailValidateMsg');
              } else {
                valid = true;
                message = '';
              }

              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              status = _context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status;

              if (status === 404) {
                valid = true;
                message = '';
              }

            case 12:
              setEmailValid({
                valid: valid,
                message: message
              });
              return _context2.abrupt("return", valid);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    }));

    return function validateEmailExist(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var validInviteUserEmail = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(email) {
      var valid, message, res, _error$response2, status;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              valid = false, message = '';
              _context3.prev = 1;
              _context3.next = 4;
              return validInviteUserEmailApi({
                email: email,
                status: 'pending'
              }, {
                catchError: true
              });

            case 4:
              res = _context3.sent;

              if (res && (res.status === 200 || res.status === 204)) {
                valid = false;
                message = translate('SFxAccountSettingsUserEmailValidateInviteUserMsg');
              } else {
                valid = true;
                message = '';
              }

              _context3.next = 12;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              status = _context3.t0 === null || _context3.t0 === void 0 ? void 0 : (_error$response2 = _context3.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status;

              if (status === 404) {
                valid = true;
                message = '';
              }

            case 12:
              setEmailValid({
                valid: valid,
                message: message
              });
              return _context3.abrupt("return", valid);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 8]]);
    }));

    return function validInviteUserEmail(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var autoFillName = function autoFillName(email) {
    if (onInputChange) {
      if (!FirstName) {
        onInputChange('FirstName', email.split('@')[0].split('.')[0]);
      }

      if (!LastName) {
        onInputChange('LastName', email.split('@')[0].split('.')[1]);
      }
    }
  };

  var checkEmailAsync = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(email) {
      var isEmailValid, checkEmailValid, _checkEmailValid;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _checkEmailValid = function _checkEmailValid3() {
                _checkEmailValid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                  var validGenericSuccess, validExistSuccess;
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return validateGeneric(email);

                        case 2:
                          validGenericSuccess = _context4.sent;

                          if (!(validGenericSuccess === false)) {
                            _context4.next = 5;
                            break;
                          }

                          return _context4.abrupt("return", false);

                        case 5:
                          _context4.next = 7;
                          return validateEmailExist(email);

                        case 7:
                          validExistSuccess = _context4.sent;

                          if (!(validExistSuccess === false)) {
                            _context4.next = 10;
                            break;
                          }

                          return _context4.abrupt("return", false);

                        case 10:
                          if (!isCheckInvitedUser) {
                            _context4.next = 14;
                            break;
                          }

                          _context4.next = 13;
                          return validInviteUserEmail(email);

                        case 13:
                          return _context4.abrupt("return", _context4.sent);

                        case 14:
                          return _context4.abrupt("return", true);

                        case 15:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));
                return _checkEmailValid.apply(this, arguments);
              };

              checkEmailValid = function _checkEmailValid2() {
                return _checkEmailValid.apply(this, arguments);
              };

              setCheckEmailLoading(true);
              _context5.next = 5;
              return checkEmailValid();

            case 5:
              isEmailValid = _context5.sent;
              isEmailValid && autoFillName(email);
              setCheckEmailLoading(false);

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function checkEmailAsync(_x4) {
      return _ref4.apply(this, arguments);
    };
  }();

  var emailUniquenessCheck = useDebounce(function (email) {
    var emailValid = validateEmail(email.trim());

    if (!emailValid.valid) {
      setEmailValid(emailValid);
      return;
    }

    if (duplicateEmailCheck) {
      if (duplicateEmailCheck(email)) {
        setEmailValid({
          valid: false,
          message: translate('SFxAccountSettingsUserEmailValidateMsg')
        });
        return;
      }
    }

    checkEmailAsync(email);
  }, 1000);

  var onChange = function onChange(e) {
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;

    if (name === "userName") {
      setEmailValid({
        valid: false,
        message: ""
      });
      emailUniquenessCheck(value.trim());
    }

    onInputChange && onInputChange(name, value);
  };

  var onClear = function onClear(label) {
    onInputChange && onInputChange(label, '');
  };

  useEffect(function () {
    onEmailValidChange && onEmailValidChange(emailValid.valid);
  }, [emailValid, onEmailValidChange]);
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "Email"
  }, translate('SFxAccountSettingsUserEmailLabel')), /*#__PURE__*/React.createElement(Input, {
    className: checkEmailLoading ? "".concat(prefix, "-input-show-icon") : "",
    readOnly: modalType === "edit",
    type: "text",
    name: "userName",
    value: userName || "",
    onChange: onChange,
    maxLength: 50,
    autoComplete: "off"
  }), checkEmailLoading && /*#__PURE__*/React.createElement(Spinner, {
    className: "".concat(prefix, "-input-loading-icon"),
    size: "sm",
    color: "#fff"
  }), userName && !checkEmailLoading && modalType !== "edit" && /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-input-close-icon"),
    onClick: function onClick() {
      return onClear('userName');
    }
  }, /*#__PURE__*/React.createElement(IconClose, {
    size: 18
  })), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-require-message")
  }, emailValid.message))), /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "FirstName"
  }, translate('SFxAccountSettingsFirstNameLabel')), /*#__PURE__*/React.createElement(Input, {
    className: FirstName ? "".concat(prefix, "-input-show-icon") : "",
    type: "text",
    name: "FirstName",
    value: FirstName || "",
    onChange: onChange,
    maxLength: 50,
    autoComplete: "off"
  }), FirstName && /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-input-close-icon"),
    onClick: function onClick() {
      return onClear('FirstName');
    }
  }, /*#__PURE__*/React.createElement(IconClose, {
    size: 18
  })))), /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "LastName"
  }, translate('SFxAccountSettingsLastNameLabel')), /*#__PURE__*/React.createElement(Input, {
    className: LastName ? "".concat(prefix, "-input-show-icon") : "",
    type: "text",
    name: "LastName",
    value: LastName || "",
    onChange: onChange,
    maxLength: 50,
    autoComplete: "off"
  }), LastName && /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-input-close-icon"),
    onClick: function onClick() {
      return onClear('LastName');
    }
  }, /*#__PURE__*/React.createElement(IconClose, {
    size: 18
  })))));
};

export default EmailInfo;